module.exports = __webpack_public_path__ + "assets/img/qianli.d6443309.svg";